import { render } from "./PlatformDetailsGUI.vue?vue&type=template&id=0d5a2c60"
import script from "./PlatformDetailsGUI.vue?vue&type=script&lang=js"
export * from "./PlatformDetailsGUI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__